import { useEffect, useMemo, useState } from 'react';
import { Icon, IconButton, LinearProgress, Pagination, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { FerramentasDaListagem } from '../../shared/components';
import { LayoutBaseDePagina } from '../../shared/layouts';
import { useDebounce } from '../../shared/hooks';
import { Environment } from '../../shared/environment';
import { useAuth } from '../../shared/contexts';
import { TicketsServiceAPI } from '../../shared/services/api/ticket/TicketsService';
import ConfirmDeleteDialog from './components/ConfirmDeleteDialog';
import { IFormTicketData } from '../../shared/types/types';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';

export const ListagemDeTickets: React.FC = () => {
  //const { contextValue } = useAuthContext();
  const { getUser } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const { debounce } = useDebounce();
  const navigate = useNavigate();

  const [rows, setRows] = useState<IFormTicketData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [ticket, setTicket] = useState<any>();

  const busca = useMemo(() => {
    return searchParams.get('busca') || '';
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);
 
  useEffect(() => {
    console.log('getUser', getUser());
    setIsLoading(true);

    debounce(() => {
      TicketsServiceAPI.getTickets(getUser(), busca, pagina)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            alert(result.message);
          } else {
            setTotalCount(result.data.totalElements);
            //setTotalCount(result.data.content.length); // Atualiza o total de elementos com o valor retornado pela API

            /* Ordenando os tickets pela data de criação (dt_created)
            const sortedRows = result.data.content((a: IFormTicketData, b: IFormTicketData) => {
              // Verificando se dt_created existe antes de acessar
              const dateA = a.dt_created ? new Date(a.dt_created).getTime() : 0;
              const dateB = b.dt_created ? new Date(b.dt_created).getTime() : 0;
              return dateB - dateA; // Ordenação decrescente
            }); */
            setRows(result.data.content); // Atualiza as linhas exibidas com os dados da página atual
          }
        })
        .catch((error) => {
          setIsLoading(false);
          alert("Erro ao carregar os tickets: " + error.message);
        });
    });
  }, [busca, pagina]);

  const handleQuickCreateTicket = () => {
    TicketsServiceAPI.quickCreateTicket(getUser())
    .then((result) => {
      console.log('--handleQuickCreateTicket--', result.data);
      if(result.data.message !== undefined) {
        alert(result.data.message);
        return;
      }else {
        var ticket = {
          id: result.data.id,
          pass_connection: result.data.pass_connection
        };
        handleOpenModal(ticket);
      }
    });
  };

  const handleOpenModal = (ticket: any) => {
    setOpenModal(true);
    setTicket(ticket);
    console.log('ticket', ticket);
    console.log('openModal', ticket + ' id: ' + ticket.id + ' pass: ' + ticket.pass_connection);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  
  const handleDelete = (id: string | undefined) => {
    if (id) {
      setSelectedId(id);
    }
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    if (selectedId) {
      TicketsServiceAPI.deleteById(getUser(), selectedId)
        .then(result => {
          if (result instanceof Error) {
            setSnackbarMessage(result.message);
          } else {
            setRows(oldRows => [
              ...oldRows.filter(oldRow => oldRow.id !== selectedId),
            ]);
            setSnackbarMessage('Registro apagado com sucesso!');
          }
          setSnackbarOpen(true);
          setOpenDialog(false);
          setSelectedId(null);
        });
    }
  };

  return (      
    <LayoutBaseDePagina
      titulo='Listagem de tickets'
      barraDeFerramentas={
        // <FerramentasDaListagem
        //   mostrarInputBusca
        //   textoDaBusca={busca}
        //   textoBotaoNovo='Nova'
        //   aoClicarEmNovo={() => navigate('/tickets/detalhe/nova')}
        //   aoMudarTextoDeBusca={texto => setSearchParams({ busca: texto, pagina: '1' }, { replace: true })}
        // />
        <FerramentasDaListagem
          mostrarInputBusca
          textoDaBusca={busca}
          aoMudarTextoDeBusca={texto => setSearchParams({ busca: texto, pagina: '1' }, { replace: true })}
          {...(getUser().data.rol == 'ADMIN'
            ? {
                textoBotaoNovo: 'Nova',
                aoClicarEmNovo: () => navigate('/tickets/detalhe/nova'),
              }
            : {
                textoBotaoNovo: 'Criar Ticket',
                aoClicarEmNovo: () => handleQuickCreateTicket(),
              })}
        />

      }
    >
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{bgcolor: 'background.paper', width: 400 }} className="modal">
          <div className="flex justify-end">
            <Button onClick={handleCloseModal}>X</Button>
          </div>
          <p className='text-5xl'>Senha: {ticket?.pass_connection ?? "Senha não disponível"}</p>
        </Box>
      </Modal>
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell width={120}>Ações</TableCell>
              <TableCell>Parceiro</TableCell>
              <TableCell>Usuário</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Tempo Contratado</TableCell>
              <TableCell>Criado em</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <IconButton size="small" onClick={() => handleOpenModal(row)} >
                    <Icon>visibility</Icon>
                  </IconButton>
                  <IconButton size="small" onClick={() => navigate(`/tickets/detalhe/${row.id}`)}>
                    <Icon>search</Icon>
                  </IconButton>
                  <IconButton size="small" onClick={() => handleDelete(row.id)}>
                    <Icon>delete</Icon>
                  </IconButton>
                </TableCell>
                <TableCell>{row.customer.nome_customer}</TableCell>
                <TableCell>{['CREATED', 'AWAITING PAYMENT', 'PAYMENT ERROR', 'EXPIRED'].includes(row.stats || '') && row.type === 'Normal' ? '****' : row.user_connection}</TableCell>
                <TableCell>{row.stats}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.time_connection}</TableCell>
                <TableCell>
                  {row.dt_created ? new Date(row.dt_created).toLocaleString() : '-'}
                </TableCell>

              </TableRow>
            ))}
          </TableBody>


          {totalCount === 0 && !isLoading && (
            <caption>{Environment.LISTAGEM_VAZIA}</caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(totalCount > 0 && totalCount > Environment.LIMITE_DE_LINHAS) && (
              <TableRow>
                <TableCell colSpan={3}>
                  <Pagination
                    page={pagina} // Utiliza a página correta
                    count={Math.ceil(totalCount / Environment.LIMITE_DE_LINHAS)} // Calcula o número total de páginas
                    onChange={(_, newPage) => setSearchParams({ busca, pagina: newPage.toString() }, { replace: true })} // Altera o parâmetro de busca e página
                  />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
      <ConfirmDeleteDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={handleConfirmDelete}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
    </LayoutBaseDePagina>
    
  );
};